import { useContext } from 'react';

import { SearchContext } from './index';

export function useSearch() {
  return useContext(SearchContext);
}
